import React from 'react';
import { useNavigate } from 'react-router-dom';

const LumeraLogo = ({ size = 'default', clickable = true, className = '' }) => {
  const navigate = useNavigate();

  const sizeMap = {
    xs: { img: 28, text: 'text-sm' },
    sm: { img: 32, text: 'text-base' },
    default: { img: 38, text: 'text-lg' },
    lg: { img: 48, text: 'text-xl' },
    xl: { img: 64, text: 'text-2xl' },
  };

  const s = sizeMap[size] || sizeMap.default;

  return (
    <div
      data-testid="lumera-logo"
      className={`flex items-center gap-2.5 ${clickable ? 'cursor-pointer' : ''} ${className}`}
      onClick={clickable ? () => navigate('/') : undefined}
    >
      <img
        src="/lumera-logo.png"
        alt="Create by Lumera"
        className="rounded-full object-cover flex-shrink-0"
        style={{ width: s.img, height: s.img }}
      />
      <span className={`${s.text} font-semibold tracking-tight text-foreground`} style={{ fontFamily: "'Playfair Display', serif" }}>
        Lumera
      </span>
    </div>
  );
};

export default LumeraLogo;
